<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="illustype_image_text"><div class="image_text"><img alt="e9781459262027_i0001.jpg" src="e9781459262027_i0001.jpg"/></div></div>
<a id="title1"></a><div class="title-frontMatter"><strong class="b">Three houses, three</strong> <strong class="b">couples—three reasons</strong> <strong class="b">for revenge</strong></div>
<div class="p"><span><strong class="b">The calm ambience of St. Fiacre’s Hill—where lavish homes provided a secure haven for the seriously rich—hid a mael-strom of feeling. Geraint Howell-Williams, Triss Alexander and Dominic Dashwood all thought they had a need to avenge—but the actions each set in motion gained a steam-roller life of their own, with entirely unexpected results.</strong></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span><strong class="b">GETTING EVEN is the first book in Sharon Kendrick’s REVENGE IS SWEET trilogy. Look out for Triss’s story coming next month in KISS AND TELL (#1951), and Dominic’s story, SETTLING THE SCORE (#1957), is out in May.</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459262027_fm01.vue?89687f4c